'use strict';

var React = require('react');

var SvgViewportNarrowMajor = function SvgViewportNarrowMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.414 9h4.586a1 1 0 1 1 0 2h-4.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 1 1 1.414 1.414l-1.293 1.293zm-8.707-2.707 3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.631-.324 1 1 0 0 1 .217-1.09l1.293-1.293h-4.586a1 1 0 0 1 0-2h4.586l-1.293-1.293a1 1 0 0 1 1.414-1.414zm2.293-4.293v4l-2-2v-2.5a1.5 1.5 0 0 1 1.5-1.5h5a1.5 1.5 0 0 1 1.5 1.5v2.5l-2 2v-4h-4zm6 14-2-2v4h-4v-4l-2 2v2.5a1.5 1.5 0 0 0 1.5 1.5h5a1.5 1.5 0 0 0 1.5-1.5v-2.5z"
  }));
};

exports.SvgViewportNarrowMajor = SvgViewportNarrowMajor;
